import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PackageCarousel from "./package-carousel";
import InstagramIcon from "@mui/icons-material/Instagram";

const Registration = () => {
    const onInstagramClick = () => {
        window.open('http://www.instagram.com/milena_meliksetyan/')
    }

    const [value, setValue] = React.useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className={'wrapper blocks-wrapper'}>
            <div className={'registration-block'}>
                <Box sx={{width: '100%'}}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                    >
                        <Tab sx={{fontSize: '16px', fontWeight: 'bold'}}
                             value={1} label="մաս-մաս վճարում"
                        />
                        <Tab sx={{fontSize: '16px', fontWeight: 'bold'}}
                             value={2} label="Իդրամով"
                        />
                    </Tabs>
                </Box>
                {value === 2 && <>
                    <PackageCarousel onInstagramClick={onInstagramClick}/></>}
                {
                    value === 1 && (<div className={'pay-block'}>
                        <p>✅ Մաս-մաս վճարման տարբերակով գրանցումը հասատվում է կանխավճարով, որը կազմում է 20.000
                            դրամ:
                        </p>
                        <br/>
                        <p>Հաշվեհամար՝ 2050092606187001</p>
                        <p>Քարտ՝ 5406610004408337</p>
                        <br/>
                        <p>Կանխավճարը կատարելուց հետո վճարման կտրոնը անհրաժեշտ է ուղարկել Միլենա Մելիքսեթյանի
                            ինստագրամյան էջին և ՎԵՐՋ 😍
                        </p>
                        <p>Ձեր գրանցումը հաստատված է ✅
                        </p>
                        <div className={'insta-wrapper'}>
                            <p>Ինստագրամյան էջը` </p>
                            <div className={'icon-wrapper'}>
                                <InstagramIcon onClick={onInstagramClick} sx={{color: "#bb003b"}}/>
                            </div>
                        </div>
                    </div>)
                }
            </div>
        </div>
    );
};

export default Registration;
